<div class="d-flex align-items-center p-2" style="background-color: var(--color-zitec-primary)">
  <ng-container [ngTemplateOutlet]="customTitleTemplate() || defaultTitle"> </ng-container>
  <ng-template #defaultTitle>
    <div class="flex-grow-1">
      <h4 class="dialog-title s-mb-3 fw-bold fs-5 c-white">
        {{ title() | translate }}
      </h4>
    </div>
  </ng-template>
  <div>
    <button
      type="button"
      mat-icon-button
      aria-label="close"
      [matTooltip]="'close' | translate"
      mat-dialog-close
      [disabled]="!allowClose()"
    >
      <mat-icon class="close-header">close</mat-icon>
    </button>
  </div>
</div>
@if (contentTemplate()) {
  <mat-dialog-content>
    <ng-container [ngTemplateOutlet]="contentTemplate()"> </ng-container>
  </mat-dialog-content>
}
<mat-dialog-actions align="end" class="d-flex gap-2">
  <z-button
    mat-dialog-close
    [matTooltip]="'COMMON.CLOSE' | translate"
    [matType]="'stroked'"
    [color]="'error'"
    [icon]="'close'"
    [label]="'COMMON.CLOSE' | translate"
    [disabled]="!allowClose()"
  >
  </z-button>
  @if (actionButtonsTemplate()) {
    <ng-container [ngTemplateOutlet]="actionButtonsTemplate()"> </ng-container>
  }
</mat-dialog-actions>
